// Gold Copy reports before numeric difficulty transport are string-only.
// Current report presence must take precedence, even when its raw value is
// invalid, so a stale Easy label cannot qualify an unrated current record.

const hasOwn = (value, key) => Object.prototype.hasOwnProperty.call(value || {}, key);

const CURRENT_RATINGS = {
  126560000: { complexity: "Low", priorityDifficulty: "Easy" },
  126560001: { complexity: "Medium", priorityDifficulty: "Medium" },
  126560002: { complexity: "High", priorityDifficulty: "Hard" },
};
const LEGACY_COMPLEXITY = Object.assign(Object.create(null), {
  Easy: "Low",
  Medium: "Medium",
  Hard: "High",
  Low: "Low",
  High: "High",
});

export const isCurrentRawDifficulty = (setting) => hasOwn(setting, "difficulty_value");

const currentRating = (setting) => (
  typeof setting?.difficulty_value === "number" && Number.isInteger(setting.difficulty_value)
    ? CURRENT_RATINGS[setting.difficulty_value] || null
    : null
);

export function complexityForDisplay(setting) {
  if (isCurrentRawDifficulty(setting)) return currentRating(setting)?.complexity || null;
  const historical = setting?.difficulty;
  return Object.prototype.hasOwnProperty.call(LEGACY_COMPLEXITY, historical)
    ? LEGACY_COMPLEXITY[historical]
    : (typeof historical === "string" && historical.trim() ? historical : null);
}

export const impactRiskForDisplay = (setting) => setting?.user_impact || null;

export function priorityDifficultyFor(setting) {
  if (isCurrentRawDifficulty(setting)) return currentRating(setting)?.priorityDifficulty || null;
  return setting?.difficulty || null;
}

export function isQuickWinRating(setting) {
  const lowComplexity = isCurrentRawDifficulty(setting)
    ? setting?.difficulty_value === 126560000
    : setting?.difficulty === "Easy";
  const impact = impactRiskForDisplay(setting);
  return lowComplexity && (impact === "None" || impact === "Low");
}

export function ratingFieldsForRecommendation(setting = {}) {
  const explanations = {
    complexity_explanation: setting.complexity_explanation || null,
    impact_risk_explanation: setting.impact_risk_explanation || null,
  };
  if (!isCurrentRawDifficulty(setting)) return {
    difficulty: setting.difficulty || null,
    user_impact: setting.user_impact || null,
    ...explanations,
  };
  const rating = currentRating(setting);
  return {
    difficulty: setting.difficulty || null,
    user_impact: setting.user_impact || null,
    difficulty_value: setting.difficulty_value ?? null,
    complexity: rating?.complexity || null,
    priority_difficulty: rating?.priorityDifficulty || null,
    ...explanations,
  };
}
